<template>
  <section id="contact" class="py-20">
    <div class="max-w-6xl mx-auto px-6">
      <div class="text-center mb-12">
        <h2 class="text-3xl md:text-4xl font-bold mb-4" :class="isDark ? 'text-white' : 'text-gray-800'">联系我</h2>
        <div class="w-20 h-1 bg-gradient-to-r from-blue-600 to-purple-600 mx-auto"></div>
      </div>
      <div class="grid md:grid-cols-2 gap-12">
        <div>
          <h3 class="text-xl font-semibold mb-6" :class="isDark ? 'text-white' : 'text-gray-800'">联系方式</h3>
          <div class="space-y-6">
            <div class="flex items-center">
              <div class="w-12 h-12 rounded-lg flex items-center justify-center" :class="isDark ? 'bg-blue-500/20' : 'bg-blue-100'">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" :class="isDark ? 'text-blue-400' : 'text-blue-600'" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
              </div>
              <div class="ml-4">
                <p class="text-sm" :class="isDark ? 'text-gray-400' : 'text-gray-500'">QQ</p>
                <p class="font-medium" :class="isDark ? 'text-gray-300' : 'text-gray-800'">684329</p>
              </div>
            </div>
            <div class="flex items-center">
              <div class="w-12 h-12 rounded-lg flex items-center justify-center" :class="isDark ? 'bg-blue-500/20' : 'bg-blue-100'">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" :class="isDark ? 'text-blue-400' : 'text-blue-600'" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <div class="ml-4">
                <p class="text-sm" :class="isDark ? 'text-gray-400' : 'text-gray-500'">邮箱</p>
                <p class="font-medium" :class="isDark ? 'text-gray-300' : 'text-gray-800'">panzhijie@qq.com</p>
              </div>
            </div>
            <div class="flex items-center">
              <div class="w-12 h-12 rounded-lg flex items-center justify-center" :class="isDark ? 'bg-purple-500/20' : 'bg-purple-100'">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" :class="isDark ? 'text-purple-400' : 'text-purple-600'" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <div class="ml-4">
                <p class="text-sm" :class="isDark ? 'text-gray-400' : 'text-gray-500'">地址</p>
                <p class="font-medium" :class="isDark ? 'text-gray-300' : 'text-gray-800'">温州市鹿城区</p>
              </div>
            </div>
          </div>
          <div class="mt-8">
            <h4 class="font-medium mb-4" :class="isDark ? 'text-gray-300' : 'text-gray-800'">社交链接</h4>
            <div class="flex space-x-4">
              <a href="#" class="w-10 h-10 rounded-full flex items-center justify-center transition-colors"
                 :class="isDark ? 'bg-gray-700 hover:bg-blue-600 hover:text-white text-gray-400' : 'bg-gray-200 hover:bg-blue-600 hover:text-white'">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.7-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.087 2.91.831.092-.646.35-1.086.636-1.336-2.22-.253-4.555-1.11-4.555-4.943 0-1.091.39-1.984 1.029-2.683-.103-.253-.446-1.27.098-2.647 0 0 .84-.268 2.75 1.026A9.578 9.578 0 0110 4.844c.85.004 1.705.114 2.504.336 1.909-1.294 2.747-1.026 2.747-1.026.546 1.377.203 2.394.1 2.647.64.699 1.028 1.592 1.028 2.683 0 3.842-2.339 4.687-4.566 4.935.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.743 0 .267.18.579.688.482C17.138 18.199 20 14.426 20 10.017 20 4.484 15.522 0 10 0z" clip-rule="evenodd" />
                </svg>
              </a>
              <a href="#" class="w-10 h-10 rounded-full flex items-center justify-center transition-colors"
                 :class="isDark ? 'bg-gray-700 hover:bg-blue-500 hover:text-white text-gray-400' : 'bg-gray-200 hover:bg-blue-500 hover:text-white'">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clip-rule="evenodd" />
                </svg>
              </a>
              <a href="#" class="w-10 h-10 rounded-full flex items-center justify-center transition-colors"
                 :class="isDark ? 'bg-gray-700 hover:bg-green-600 hover:text-white text-gray-400' : 'bg-gray-200 hover:bg-green-600 hover:text-white'">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
              </a>
              <a href="#" class="w-10 h-10 rounded-full flex items-center justify-center transition-colors"
                 :class="isDark ? 'bg-gray-700 hover:bg-red-600 hover:text-white text-gray-400' : 'bg-gray-200 hover:bg-red-600 hover:text-white'">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10 15a5 5 0 100-10 5 5 0 000 10zm0-2a3 3 0 110-6 3 3 0 010 6z" />
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2a1 1 0 00.293.707l3 3a1 1 0 001.414-1.414l-3-3A1 1 0 0011 7z" clip-rule="evenodd" />
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div>
          <h3 class="text-xl font-semibold mb-6" :class="isDark ? 'text-white' : 'text-gray-800'">发送消息</h3>
          <form @submit.prevent="handleSubmit" class="space-y-4">
            <div>
              <label class="block text-sm mb-2" :class="isDark ? 'text-gray-400' : 'text-gray-600'">姓名</label>
              <input v-model="form.name" type="text" 
                     class="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors"
                     :class="isDark ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' : 'bg-white border-gray-300'"
                     placeholder="请输入您的姓名" />
            </div>
            <div>
              <label class="block text-sm mb-2" :class="isDark ? 'text-gray-400' : 'text-gray-600'">邮箱</label>
              <input v-model="form.email" type="email" 
                     class="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors"
                     :class="isDark ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' : 'bg-white border-gray-300'"
                     placeholder="请输入您的邮箱" />
            </div>
            <div>
              <label class="block text-sm mb-2" :class="isDark ? 'text-gray-400' : 'text-gray-600'">消息</label>
              <textarea v-model="form.message" rows="5" 
                        class="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors resize-none"
                        :class="isDark ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' : 'bg-white border-gray-300'"
                        placeholder="请输入您的消息"></textarea>
            </div>
            <button type="submit" class="w-full py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-300">
              发送消息
            </button>
          </form>
          <div v-if="submitted" class="mt-4 p-4 rounded-lg" :class="isDark ? 'bg-green-500/20 text-green-400' : 'bg-green-100 text-green-700'">
            感谢您的消息！我会尽快回复您。
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { useTheme } from '../composables/useTheme'

export default {
  name: 'Contact',
  setup() {
    const { isDark } = useTheme()
    return { isDark }
  },
  data() {
    return {
      form: {
        name: '',
        email: '',
        message: ''
      },
      submitted: false
    }
  },
  methods: {
    handleSubmit() {
      this.submitted = true
      setTimeout(() => {
        this.submitted = false
        this.form = { name: '', email: '', message: '' }
      }, 3000)
    }
  }
}
</script>
